import { render, staticRenderFns } from "./ListaCampoExperiencia.vue?vue&type=template&id=80636456"
import script from "./ListaCampoExperiencia.vue?vue&type=script&lang=js"
export * from "./ListaCampoExperiencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports